export const ShopIcon = () => (
  <svg
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2 20H16C17.103 20 18 19.103 18 18V7C18 6.73478 17.8946 6.48043 17.7071 6.29289C17.5196 6.10536 17.2652 6 17 6H14V5C14 2.243 11.757 0 9 0C6.243 0 4 2.243 4 5V6H1C0.734784 6 0.48043 6.10536 0.292893 6.29289C0.105357 6.48043 0 6.73478 0 7V18C0 19.103 0.897 20 2 20ZM6 5C6 3.346 7.346 2 9 2C10.654 2 12 3.346 12 5V6H6V5ZM2 8H4V10H6V8H12V10H14V8H16L16.002 18H2V8Z" />
  </svg>
);

export const FoodIcon = () => (
  <svg
    className="stroked"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.0938 19.5C15.0938 21.157 14.1258 22.5 12.4688 22.5H6.28125C4.62422 22.5 3.65625 21.157 3.65625 19.5"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M15.75 15.75C16.5783 15.75 17.25 16.5895 17.25 17.625C17.25 18.6605 16.5783 19.5 15.75 19.5H3C2.17172 19.5 1.5 18.6605 1.5 17.625C1.5 16.5895 2.17172 15.75 3 15.75"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M16.125 15.75H8.40516C8.30583 15.75 8.21058 15.7895 8.14031 15.8597L6.88266 17.1173C6.86524 17.1348 6.84456 17.1486 6.8218 17.158C6.79904 17.1675 6.77464 17.1723 6.75 17.1723C6.72536 17.1723 6.70096 17.1675 6.6782 17.158C6.65544 17.1486 6.63476 17.1348 6.61734 17.1173L5.35969 15.8597C5.28942 15.7895 5.19417 15.75 5.09484 15.75H2.625C2.32663 15.75 2.04048 15.6315 1.8295 15.4205C1.61853 15.2095 1.5 14.9234 1.5 14.625V14.625C1.5 14.3266 1.61853 14.0405 1.8295 13.8295C2.04048 13.6185 2.32663 13.5 2.625 13.5H16.125C16.4234 13.5 16.7095 13.6185 16.9205 13.8295C17.1315 14.0405 17.25 14.3266 17.25 14.625C17.25 14.9234 17.1315 15.2095 16.9205 15.4205C16.7095 15.6315 16.4234 15.75 16.125 15.75Z"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M3 12.9375V12.9272C3 10.3491 5.10938 9 7.6875 9H11.0625C13.6406 9 15.75 10.3594 15.75 12.9375V12.9272"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M11.2969 5.25L11.6456 8.24859"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M12 22.5H18.5302C18.9086 22.5 19.273 22.3569 19.5504 22.0995C19.8278 21.8421 19.9977 21.4894 20.0259 21.112L21.7031 5.25"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M17.25 5.25L18 2.25L20.2031 1.5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 5.25H22.5"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
  </svg>
);

export const EntertainIcon = () => (
  <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24" height="24" viewBox="0 0 306.976 306.976" space="preserve"><g><path d="M230.879,144.952c-3.426-4.771-4.874-10.757-3.84-16.786l2.061-12.018l-8.73-8.51c-0.133-0.129-0.253-0.267-0.382-0.399
 c-66.809,55.733-74.408,145.071-73.68,188.929c0.027,1.598,1.254,2.919,2.846,3.067c1.591,0.148,3.039-0.925,3.361-2.491
 C170.944,206.99,205.797,164.569,230.879,144.952z"></path><path d="M99.861,85.018L79.7,89.531l-7.712,19.167c-0.14,0.348-0.298,0.685-0.454,1.023c31.466,44.515,47.854,135.4,54.405,181.181
 c0.154,1.074,1.111,1.846,2.193,1.773c1.082-0.073,1.925-0.968,1.934-2.052c0.797-98.746-14.309-164.631-29.555-205.773
 C100.294,84.904,100.081,84.969,99.861,85.018z"></path><path d="M237.742,244.904l-2.857-3.93c-2.312-3.18-3.69-6.801-4.133-10.52c-21.992,5.865-55.074,20.873-65.644,58.833
 c-0.571,2.05,0.423,4.213,2.35,5.115c1.928,0.902,4.226,0.28,5.434-1.472c11.534-16.727,32.267-38.816,63.187-43.301
 c0.017-0.048,0.029-0.097,0.046-0.146L237.742,244.904z"></path><path d="M80.479,206.57c-2.011,2.813-4.686,5.177-7.904,6.851l-4.309,2.241l-0.597,4.82c-0.18,1.452-0.504,2.857-0.943,4.21
 c18.465,20.857,32.072,49.507,40.295,70.078c0.551,1.379,2.056,2.118,3.486,1.716c1.429-0.403,2.326-1.818,2.077-3.283
 C105.303,250.21,92.568,223.285,80.479,206.57z"></path><path d="M250.59,109.166l-3.839,22.381c-0.153,0.89,0.213,1.79,0.944,2.321c0.413,0.3,0.903,0.453,1.395,0.453
 c0.378,0,0.757-0.09,1.104-0.273l20.1-10.567l20.099,10.567c0.347,0.183,0.726,0.273,1.104,0.273c0.492,0,0.982-0.153,1.395-0.453
 c0.731-0.531,1.097-1.431,0.944-2.321l-3.839-22.381l16.261-15.851c0.647-0.631,0.88-1.574,0.601-2.433
 c-0.279-0.859-1.022-1.485-1.916-1.615l-22.472-3.265l-10.05-20.363c-0.4-0.81-1.225-1.323-2.128-1.323
 c-0.903,0-1.728,0.513-2.128,1.323l-10.05,20.363l-22.472,3.265c-0.894,0.13-1.637,0.756-1.916,1.615
 c-0.279,0.859-0.046,1.802,0.6,2.433L250.59,109.166z"></path><path d="M95.493,65.501c0.882-0.197,1.575-0.878,1.788-1.756c0.213-0.878-0.09-1.8-0.783-2.38L72.588,41.36l2.925-31.037
 c0.085-0.899-0.349-1.769-1.117-2.243c-0.382-0.235-0.814-0.353-1.245-0.353c-0.438,0-0.875,0.121-1.26,0.362L45.476,24.647
 L16.861,12.275c-0.303-0.131-0.623-0.195-0.941-0.195c-0.553,0-1.1,0.193-1.537,0.564c-0.689,0.585-0.985,1.51-0.765,2.386
 l7.585,30.238L0.593,68.658c-0.597,0.678-0.758,1.636-0.414,2.471c0.344,0.836,1.132,1.404,2.033,1.465l31.102,2.131l15.877,26.829
 c0.429,0.725,1.208,1.165,2.042,1.165c0.06,0,0.12-0.002,0.181-0.007c0.901-0.068,1.684-0.642,2.022-1.48l11.637-28.921
 L95.493,65.501z"></path><path d="M302.251,235.51c-0.13-0.894-0.757-1.636-1.616-1.915l-14.62-4.745l-4.379-14.734c-0.257-0.866-0.984-1.511-1.874-1.663
 c-0.134-0.023-0.268-0.034-0.401-0.034c-0.752,0-1.469,0.358-1.92,0.979l-9.031,12.439l-15.366-0.388
 c-0.02,0-0.04-0.001-0.06-0.001c-0.88,0-1.69,0.488-2.1,1.269c-0.42,0.8-0.35,1.769,0.181,2.499l9.039,12.433l-5.118,14.495
 c-0.301,0.852-0.092,1.8,0.539,2.447c0.454,0.465,1.069,0.716,1.699,0.716c0.245,0,0.493-0.038,0.734-0.116l14.618-4.755
 l12.204,9.346c0.422,0.323,0.931,0.489,1.443,0.489c0.358,0,0.717-0.081,1.051-0.245c0.81-0.4,1.323-1.225,1.322-2.129
 l-0.005-15.371l12.66-8.718C301.993,237.295,302.381,236.404,302.251,235.51z"></path><path d="M63.347,195.678c0.801-0.417,1.297-1.252,1.278-2.156c-0.019-0.903-0.549-1.717-1.368-2.1l-13.925-6.51l-2.531-15.161
 c-0.149-0.891-0.79-1.62-1.655-1.881c-0.226-0.068-0.457-0.101-0.685-0.101c-0.647,0-1.279,0.265-1.734,0.753l-10.494,11.232
 l-15.202-2.278c-0.118-0.018-0.235-0.026-0.352-0.026c-0.77,0-1.501,0.375-1.948,1.019c-0.516,0.742-0.565,1.712-0.128,2.503
 l7.439,13.452l-6.864,13.754c-0.403,0.808-0.313,1.775,0.233,2.495c0.454,0.598,1.156,0.938,1.89,0.938
 c0.15,0,0.301-0.014,0.451-0.043l15.092-2.918l10.96,10.778c0.451,0.444,1.052,0.681,1.665,0.681c0.262,0,0.525-0.043,0.78-0.132
 c0.853-0.297,1.463-1.053,1.574-1.949l1.889-15.255L63.347,195.678z"></path><path d="M164.224,67.025l-1.845-4.493l-4.748-1.027c-3.545-0.767-6.747-2.343-9.427-4.526c-7.651,20.35-13.008,51.827-7.374,99.172
 c0.303,2.548,4.02,2.518,4.262-0.036c2.083-21.962,7.451-57.474,21.156-85.27C165.465,69.654,164.781,68.381,164.224,67.025z"></path><path d="M170.993,12.588l1.552,15.293l-11.718,9.948c-0.689,0.585-0.986,1.509-0.766,2.386c0.219,0.876,0.917,1.552,1.8,1.743
 l15.024,3.25l5.84,14.219c0.343,0.836,1.131,1.404,2.032,1.466c0.055,0.004,0.109,0.006,0.163,0.006
 c0.84,0,1.624-0.446,2.051-1.179l7.734-13.284l15.328-1.16c0.901-0.068,1.685-0.642,2.022-1.48c0.337-0.838,0.17-1.795-0.432-2.468
 l-10.244-11.46l3.633-14.936c0.214-0.878-0.09-1.801-0.783-2.381c-0.435-0.364-0.977-0.554-1.524-0.554
 c-0.324,0-0.65,0.066-0.957,0.202l-14.065,6.201L174.6,10.329c-0.382-0.236-0.814-0.353-1.246-0.353
 c-0.437,0-0.875,0.121-1.26,0.362C171.329,10.817,170.902,11.689,170.993,12.588z"></path></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>
);

export const SalesIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.0263 13.9102L11.9258 13.3904L10.7593 12.4092L11.0263 13.9102Z" />
    <path d="M22.1395 12.2995C22.1395 12.0827 22.0307 11.8921 21.8652 11.7725L21.8687 11.7666L19.5377 10.4477L20.8795 8.17005L20.875 8.16735C20.9173 8.07348 20.9366 7.97114 20.931 7.86863C20.9255 7.76613 20.8954 7.66634 20.8432 7.57736C20.7906 7.48846 20.7174 7.41297 20.6294 7.35703C20.5414 7.30109 20.4412 7.26627 20.337 7.25541V7.24904H17.645V4.61831H17.6395C17.6283 4.51625 17.5927 4.41821 17.5356 4.33214C17.4785 4.24606 17.4016 4.17438 17.311 4.12289C17.22 4.07156 17.118 4.04202 17.0132 4.0367C16.9084 4.03138 16.8038 4.05042 16.708 4.09227L16.7047 4.08663L14.3345 5.42784L13.022 3.19968L13.0172 3.20237C12.9554 3.11949 12.8746 3.05204 12.7813 3.00547C12.6879 2.9589 12.5847 2.93453 12.48 2.93433C12.2587 2.93433 12.064 3.04091 11.9422 3.20311L11.9362 3.19968L10.602 5.46459L8.30447 4.16455L8.30172 4.1692C8.20594 4.12766 8.10152 4.10884 7.99692 4.11424C7.89233 4.11965 7.79051 4.14914 7.69972 4.20032C7.60895 4.25183 7.53187 4.32362 7.47475 4.40983C7.41762 4.49604 7.38207 4.59425 7.37097 4.69647H7.36422V7.31176H4.71122V7.31691C4.60708 7.32788 4.50704 7.36275 4.41922 7.41869C4.3314 7.47462 4.25825 7.55005 4.20572 7.63885C4.15347 7.72792 4.1234 7.82781 4.11792 7.93041C4.11245 8.033 4.13174 8.13542 4.17422 8.22934L4.16847 8.23277L5.47997 10.4592L3.13147 11.7882L3.13422 11.7928C3.04965 11.8534 2.98082 11.9326 2.93331 12.0241C2.88579 12.1156 2.86092 12.2167 2.86072 12.3194C2.86072 12.5362 2.96947 12.7271 3.13497 12.8464L3.13147 12.8523L5.46247 14.1712L4.12072 16.4488L4.12522 16.4513C4.08284 16.5452 4.06363 16.6475 4.06914 16.75C4.07466 16.8525 4.10475 16.9523 4.15697 17.0413C4.20958 17.1302 4.28284 17.2057 4.3708 17.2616C4.45876 17.3176 4.55895 17.3524 4.66322 17.3632V17.3699H7.35497V20.0003H7.36047C7.38347 20.2003 7.49772 20.3875 7.68897 20.4958C7.77992 20.547 7.88194 20.5765 7.98672 20.5819C8.09151 20.5872 8.1961 20.5682 8.29197 20.5264L8.29522 20.532L10.6655 19.1908L11.978 21.419L11.9827 21.4163C12.0445 21.4992 12.1253 21.5666 12.2187 21.6132C12.312 21.6598 12.4152 21.6841 12.52 21.6843C12.7412 21.6843 12.936 21.5777 13.0577 21.4158L13.0635 21.419L14.3977 19.1541L16.6955 20.4541L16.6982 20.4495C16.794 20.491 16.8984 20.5098 17.003 20.5044C17.1076 20.499 17.2094 20.4695 17.3002 20.4183C17.391 20.3668 17.4681 20.2951 17.5252 20.2089C17.5824 20.1226 17.6179 20.0244 17.629 19.9222H17.6357V17.3071H20.289V17.302C20.3931 17.291 20.4931 17.2561 20.581 17.2002C20.6688 17.1443 20.7419 17.0688 20.7945 16.98C20.8467 16.891 20.8768 16.7911 20.8823 16.6885C20.8877 16.5859 20.8685 16.4835 20.826 16.3896L20.8317 16.3864L19.5202 14.1599L21.8687 12.831L21.866 12.8263C21.9505 12.7657 22.0194 12.6864 22.0669 12.5949C22.1144 12.5034 22.1393 12.4022 22.1395 12.2995ZM9.38422 16.0328C8.82672 16.3484 8.32122 16.3915 7.89147 16.2783L7.95172 15.6175C8.27722 15.7099 8.69797 15.7094 9.09547 15.4842C9.43722 15.2909 9.50997 15.0518 9.41272 14.8869C9.12297 14.3954 7.66472 15.6783 7.03797 14.6147C6.76097 14.1442 6.94622 13.5192 7.62547 13.135C8.08372 12.8756 8.54422 12.7962 8.98197 12.893L8.90472 13.5356C8.54647 13.4562 8.17772 13.5346 7.88372 13.7008C7.62422 13.8478 7.54197 14.0411 7.64197 14.2109C7.90422 14.6558 9.38322 13.418 10.0047 14.4728C10.3095 14.9895 10.1587 15.595 9.38422 16.0328ZM12.87 13.9928L12.4065 13.6167L11.1697 14.3165L11.27 14.8982L10.5737 15.2919L10.02 11.8364L10.7897 11.4011L13.5662 13.5991L12.87 13.9928ZM13.8082 13.4621L12.143 10.6351L12.7615 10.285L14.1147 12.582L15.3342 11.8921L15.6465 12.422L13.8082 13.4621ZM16.0612 12.1873L14.396 9.36057L16.437 8.20533L16.749 8.73505L15.3222 9.54262L15.6717 10.136L17.0682 9.34563L17.3802 9.87535L15.9837 10.6655L16.3632 11.3099L17.7902 10.5023L18.1025 11.0321L16.0612 12.1873Z" />
  </svg>
);

export const AngleDown = (props) => (
  <svg
    width="28"
    height="16"
    viewBox="0 0 28 16"
    {...props}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.29202 1.29196C1.38491 1.19883 1.49526 1.12494 1.61675 1.07453C1.73824 1.02412 1.86848 0.998169 2.00002 0.998169C2.13155 0.998169 2.26179 1.02412 2.38329 1.07453C2.50478 1.12494 2.61513 1.19883 2.70802 1.29196L14 12.586L25.292 1.29196C25.385 1.19898 25.4954 1.12523 25.6169 1.07491C25.7383 1.02459 25.8685 0.998693 26 0.998693C26.1315 0.998693 26.2617 1.02459 26.3832 1.07491C26.5047 1.12523 26.615 1.19898 26.708 1.29196C26.801 1.38493 26.8747 1.49531 26.9251 1.61679C26.9754 1.73827 27.0013 1.86847 27.0013 1.99996C27.0013 2.13144 26.9754 2.26164 26.9251 2.38312C26.8747 2.5046 26.801 2.61498 26.708 2.70796L14.708 14.708C14.6151 14.8011 14.5048 14.875 14.3833 14.9254C14.2618 14.9758 14.1316 15.0017 14 15.0017C13.8685 15.0017 13.7382 14.9758 13.6168 14.9254C13.4953 14.875 13.3849 14.8011 13.292 14.708L1.29202 2.70796C1.19889 2.61507 1.12501 2.50471 1.07459 2.38322C1.02418 2.26173 0.99823 2.13149 0.99823 1.99996C0.99823 1.86842 1.02418 1.73818 1.07459 1.61669C1.12501 1.4952 1.19889 1.38485 1.29202 1.29196Z"
      fill="#E61F01"
    />
  </svg>
);

export const Telegram = () => (
  <svg
    className="icon tg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16 0.5C7.437 0.5 0.5 7.438 0.5 16C0.5 24.562 7.438 31.5 16 31.5C24.563 31.5 31.5 24.562 31.5 16C31.5 7.438 24.562 0.5 16 0.5ZM23.613 11.119L21.069 23.107C20.881 23.957 20.375 24.163 19.669 23.763L15.794 20.907L13.925 22.707C13.719 22.913 13.544 23.088 13.144 23.088L13.419 19.144L20.6 12.656C20.913 12.381 20.531 12.225 20.118 12.5L11.243 18.087L7.418 16.893C6.587 16.631 6.568 16.062 7.593 15.662L22.537 9.899C23.231 9.649 23.837 10.068 23.612 11.118L23.613 11.119Z" />
  </svg>
);

export const Instagram = () => (
  <svg
    className="icon instagram"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M34.9117 13.8417C34.8949 12.5794 34.6586 11.3296 34.2133 10.1483C33.8272 9.15191 33.2376 8.24699 32.4819 7.49137C31.7263 6.73576 30.8214 6.14607 29.825 5.75999C28.6589 5.32225 27.427 5.08556 26.1817 5.05999C24.5783 4.98832 24.07 4.96832 20 4.96832C15.93 4.96832 15.4083 4.96832 13.8167 5.05999C12.5719 5.08575 11.3406 5.32244 10.175 5.75999C9.17843 6.14581 8.27336 6.7354 7.51772 7.49104C6.76207 8.24669 6.17248 9.15175 5.78666 10.1483C5.34805 11.3135 5.11187 12.5452 5.08833 13.79C5.01666 15.395 4.995 15.9033 4.995 19.9733C4.995 24.0433 4.995 24.5633 5.08833 26.1567C5.11333 27.4033 5.34833 28.6333 5.78666 29.8017C6.17312 30.7979 6.76316 31.7026 7.51906 32.4579C8.27496 33.2133 9.1801 33.8026 10.1767 34.1883C11.3391 34.6437 12.5706 34.8973 13.8183 34.9383C15.4233 35.01 15.9317 35.0317 20.0017 35.0317C24.0717 35.0317 24.5933 35.0317 26.185 34.9383C27.4303 34.9138 28.6623 34.6777 29.8283 34.24C30.8245 33.8535 31.7292 33.2636 32.4847 32.5081C33.2403 31.7525 33.8301 30.8478 34.2167 29.8517C34.655 28.685 34.89 27.455 34.915 26.2067C34.9867 24.6033 35.0083 24.095 35.0083 20.0233C35.005 15.9533 35.005 15.4367 34.9117 13.8417ZM19.99 27.67C15.7333 27.67 12.285 24.2217 12.285 19.965C12.285 15.7083 15.7333 12.26 19.99 12.26C22.0335 12.26 23.9933 13.0718 25.4383 14.5167C26.8832 15.9617 27.695 17.9215 27.695 19.965C27.695 22.0085 26.8832 23.9683 25.4383 25.4132C23.9933 26.8582 22.0335 27.67 19.99 27.67ZM28.0017 13.7717C27.0067 13.7717 26.205 12.9683 26.205 11.975C26.205 11.7392 26.2514 11.5056 26.3417 11.2878C26.4319 11.0699 26.5642 10.8719 26.731 10.7051C26.8977 10.5384 27.0957 10.4061 27.3136 10.3159C27.5315 10.2256 27.765 10.1792 28.0008 10.1792C28.2367 10.1792 28.4702 10.2256 28.6881 10.3159C28.9059 10.4061 29.1039 10.5384 29.2707 10.7051C29.4374 10.8719 29.5697 11.0699 29.66 11.2878C29.7502 11.5056 29.7967 11.7392 29.7967 11.975C29.7967 12.9683 28.9933 13.7717 28.0017 13.7717Z"
      fill="#222222"
    />
    <path
      d="M19.99 24.97C22.7542 24.97 24.995 22.7292 24.995 19.965C24.995 17.2008 22.7542 14.96 19.99 14.96C17.2258 14.96 14.985 17.2008 14.985 19.965C14.985 22.7292 17.2258 24.97 19.99 24.97Z"
      fill="#222222"
    />
  </svg>
);

export const Facebook = () => (
  <svg
    className="icon facebook"
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M17.0017 0.33667C7.79834 0.33667 0.33667 7.79834 0.33667 17.0017C0.33667 25.3183 6.43 32.2117 14.3983 33.4667V21.82H10.165V17.0017H14.3983V13.33C14.3983 9.15 16.8867 6.845 20.6917 6.845C22.515 6.845 24.425 7.17 24.425 7.17V11.2683H22.3183C20.2517 11.2683 19.605 12.555 19.605 13.8733V16.9983H24.2233L23.485 21.8167H19.605V33.4633C27.5733 32.215 33.6667 25.32 33.6667 17.0017C33.6667 7.79834 26.205 0.33667 17.0017 0.33667Z" />
  </svg>
);

export const Landmark = () => (
  <svg
    width="24"
    height="34"
    viewBox="0 0 24 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.6667 12C23.6667 10.468 23.3649 8.95087 22.7786 7.53541C22.1923 6.11994 21.3329 4.83382 20.2496 3.75047C19.1662 2.66712 17.8801 1.80776 16.4646 1.22145C15.0492 0.635149 13.5321 0.333382 12 0.333382C10.4679 0.333382 8.95081 0.635149 7.53534 1.22145C6.11988 1.80776 4.83375 2.66712 3.7504 3.75047C2.66705 4.83382 1.80769 6.11994 1.22139 7.53541C0.63508 8.95087 0.333313 10.468 0.333313 12C0.333313 14.3117 1.01665 16.4617 2.17498 18.275H2.16165C6.09498 24.4334 12 33.6667 12 33.6667L21.8383 18.275H21.8267C23.0273 16.4023 23.6659 14.2246 23.6667 12ZM12 17C10.6739 17 9.40213 16.4733 8.46445 15.5356C7.52676 14.5979 6.99998 13.3261 6.99998 12C6.99998 10.674 7.52676 9.4022 8.46445 8.46451C9.40213 7.52683 10.6739 7.00005 12 7.00005C13.3261 7.00005 14.5978 7.52683 15.5355 8.46451C16.4732 9.4022 17 10.674 17 12C17 13.3261 16.4732 14.5979 15.5355 15.5356C14.5978 16.4733 13.3261 17 12 17Z"
      fill="#F3262D"
    />
  </svg>
);

export const Phone = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M33.3334 18.3317H36.6667C36.6667 9.78171 30.2117 3.33338 21.65 3.33338V6.66671C28.42 6.66671 33.3334 11.5717 33.3334 18.3317Z"
      fill="#F3262D"
    />
    <path
      d="M21.6667 13.3333C25.1717 13.3333 26.6667 14.8283 26.6667 18.3333H30C30 12.9583 27.0417 9.99995 21.6667 9.99995V13.3333ZM27.37 22.4049C27.0498 22.1139 26.6289 21.9586 26.1964 21.972C25.7638 21.9854 25.3533 22.1663 25.0517 22.4766L21.0633 26.5783C20.1033 26.3949 18.1733 25.7933 16.1867 23.8116C14.2 21.8233 13.5983 19.8883 13.42 18.9349L17.5183 14.9449C17.829 14.6435 18.0102 14.233 18.0236 13.8003C18.037 13.3676 17.8815 12.9467 17.59 12.6266L11.4317 5.85495C11.1401 5.53387 10.7348 5.33912 10.3019 5.31205C9.86906 5.28497 9.44268 5.42771 9.11335 5.70995L5.49668 8.81161C5.20853 9.1008 5.03654 9.4857 5.01335 9.89328C4.98835 10.3099 4.51168 20.1799 12.165 27.8366C18.8417 34.5116 27.205 34.9999 29.5083 34.9999C29.845 34.9999 30.0517 34.9899 30.1067 34.9866C30.5142 34.9638 30.8989 34.791 31.1867 34.5016L34.2867 30.8833C34.5691 30.5542 34.7121 30.1279 34.6854 29.695C34.6586 29.2622 34.4642 28.8568 34.1433 28.5649L27.37 22.4049Z"
      fill="#F3262D"
    />
  </svg>
);

export const BreadcrumbDivider = () => (
  <svg
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.645917 13.3541C0.599354 13.3076 0.562411 13.2525 0.537204 13.1917C0.511998 13.131 0.499023 13.0659 0.499023 13.0001C0.499023 12.9343 0.511998 12.8692 0.537204 12.8084C0.562411 12.7477 0.599354 12.6925 0.645917 12.6461L6.29292 7.00008L0.645917 1.35408C0.599429 1.3076 0.562553 1.25241 0.537394 1.19167C0.512234 1.13093 0.499285 1.06583 0.499285 1.00008C0.499285 0.93434 0.512234 0.869239 0.537394 0.808499C0.562553 0.74776 0.599429 0.692571 0.645917 0.646083C0.692405 0.599595 0.747594 0.562718 0.808333 0.53756C0.869073 0.512401 0.934173 0.499452 0.999917 0.499452C1.06566 0.499452 1.13076 0.512401 1.1915 0.53756C1.25224 0.562718 1.30743 0.599595 1.35392 0.646083L7.35392 6.64608C7.40048 6.69253 7.43742 6.7477 7.46263 6.80845C7.48784 6.86919 7.50081 6.93432 7.50081 7.00008C7.50081 7.06585 7.48784 7.13097 7.46263 7.19172C7.43742 7.25246 7.40048 7.30764 7.35392 7.35408L1.35392 13.3541C1.30747 13.4006 1.2523 13.4376 1.19155 13.4628C1.13081 13.488 1.06568 13.501 0.999917 13.501C0.93415 13.501 0.869028 13.488 0.808283 13.4628C0.747538 13.4376 0.692363 13.4006 0.645917 13.3541Z"
    />
  </svg>
);

export const SearchIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.7232 13.3047C15.9702 11.697 16.5579 9.67472 16.3667 7.64915C16.1756 5.62358 15.2199 3.74691 13.6942 2.40094C12.1684 1.05497 10.1872 0.340806 8.15365 0.403734C6.12005 0.466662 4.1868 1.30196 2.74721 2.73969C1.30637 4.17841 0.468344 6.11241 0.403912 8.14755C0.339481 10.1827 1.05349 12.1658 2.40044 13.6928C3.74739 15.2198 5.62591 16.1757 7.65319 16.3658C9.68046 16.5558 11.7039 15.9657 13.3112 14.7157L13.3542 14.7607L17.5962 19.0037C17.6891 19.0966 17.7994 19.1703 17.9208 19.2206C18.0422 19.2709 18.1723 19.2967 18.3037 19.2967C18.4351 19.2967 18.5652 19.2709 18.6866 19.2206C18.808 19.1703 18.9183 19.0966 19.0112 19.0037C19.1041 18.9108 19.1778 18.8005 19.2281 18.6791C19.2784 18.5577 19.3043 18.4276 19.3043 18.2962C19.3043 18.1648 19.2784 18.0347 19.2281 17.9133C19.1778 17.7919 19.1041 17.6816 19.0112 17.5887L14.7682 13.3467C14.7536 13.3323 14.7386 13.3183 14.7232 13.3047ZM12.6472 4.15469C13.2118 4.71017 13.6608 5.37194 13.9684 6.10182C14.276 6.83171 14.436 7.61527 14.4392 8.40731C14.4424 9.19934 14.2888 9.98418 13.9872 10.7165C13.6856 11.4489 13.242 12.1143 12.6819 12.6744C12.1218 13.2344 11.4564 13.6781 10.7241 13.9797C9.99171 14.2813 9.20687 14.4349 8.41483 14.4317C7.6228 14.4285 6.83924 14.2685 6.10935 13.9609C5.37946 13.6533 4.71769 13.2043 4.16221 12.6397C3.05213 11.5114 2.43287 9.99013 2.43931 8.40731C2.44576 6.82449 3.07739 5.30833 4.19662 4.1891C5.31586 3.06986 6.83201 2.43823 8.41483 2.43179C9.99765 2.42534 11.5189 3.04461 12.6472 4.15469Z"
      fill="white"
    />
  </svg>
);

export const BuildingIcon = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    className="stroked"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 25H25"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.66667 25V6.33333L14.3333 1V25"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.3333 25V11.6667L14.3333 6.33334"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 9V9.01333"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 13V13.0133"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 17V17.0133"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 21V21.0133"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const HelpIcon = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 24.375C16.0168 24.375 18.9101 23.1766 21.0433 21.0433C23.1766 18.9101 24.375 16.0168 24.375 13C24.375 9.98316 23.1766 7.08989 21.0433 4.95666C18.9101 2.82343 16.0168 1.625 13 1.625C9.98316 1.625 7.08989 2.82343 4.95666 4.95666C2.82343 7.08989 1.625 9.98316 1.625 13C1.625 16.0168 2.82343 18.9101 4.95666 21.0433C7.08989 23.1766 9.98316 24.375 13 24.375ZM13 26C16.4478 26 19.7544 24.6304 22.1924 22.1924C24.6304 19.7544 26 16.4478 26 13C26 9.55219 24.6304 6.24558 22.1924 3.80761C19.7544 1.36964 16.4478 0 13 0C9.55219 0 6.24558 1.36964 3.80761 3.80761C1.36964 6.24558 0 9.55219 0 13C0 16.4478 1.36964 19.7544 3.80761 22.1924C6.24558 24.6304 9.55219 26 13 26Z"
      fill="white"
    />
    <path
      d="M14.5112 10.7055L10.79 11.1719L10.6567 11.7894L11.388 11.9243C11.8657 12.038 11.96 12.2103 11.856 12.6864L10.6567 18.3219C10.3415 19.7795 10.8274 20.4653 11.9697 20.4653C12.8554 20.4653 13.884 20.0558 14.3504 19.4935L14.4934 18.8175C14.1684 19.1035 13.6939 19.2173 13.3786 19.2173C12.9317 19.2173 12.7692 18.9036 12.8846 18.3511L14.5112 10.7055Z"
      fill="white"
    />
    <path
      d="M13 8.9375C13.8975 8.9375 14.625 8.20996 14.625 7.3125C14.625 6.41504 13.8975 5.6875 13 5.6875C12.1025 5.6875 11.375 6.41504 11.375 7.3125C11.375 8.20996 12.1025 8.9375 13 8.9375Z"
      fill="white"
    />
  </svg>
);

export const RoomIcon = () => (
  <svg
    width="28"
    height="32"
    viewBox="0 0 28 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 32L0 26L18 28V4L6 8V24L0 26V6L18 0L28 4V28L18 32Z"
      fill="white"
    />
  </svg>
);

export const WorkingHours = () => (
  <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="40" height="40"
    viewBox="0 0 480 480" style={{ fill: "red", enableBackground: "new 0 0 480 480" }} space="preserve">
    <g>
      <g>
        <path d="M240,0C107.452,0,0,107.452,0,240s107.452,240,240,240s240-107.452,240-240C479.85,107.514,372.486,0.15,240,0z M240,464
			C116.288,464,16,363.712,16,240S116.288,16,240,16s224,100.288,224,224C463.859,363.653,363.653,463.859,240,464z"/>
      </g>
    </g>
    <g>
      <g>
        <path d="M240,40C129.543,40,40,129.543,40,240s89.543,200,200,200s200-89.543,200-200C439.877,129.594,350.406,40.123,240,40z
			 M240,424c-101.62,0-184-82.38-184-184S138.38,56,240,56s184,82.38,184,184C423.885,341.573,341.573,423.885,240,424z"/>
      </g>
    </g>
    <g>
      <g>
        <rect x="232" y="80" width="16" height="16" />
      </g>
    </g>
    <g>
      <g>
        <rect x="232" y="384" width="16" height="16" />
      </g>
    </g>
    <g>
      <g>

        <rect x="155.999" y="100.37" transform="matrix(0.8659 -0.5001 0.5001 0.8659 -32.2136 96.5469)" width="15.992" height="15.992" />
      </g>
    </g>
    <g>
      <g>

        <rect x="307.98" y="363.598" transform="matrix(0.8659 -0.5001 0.5001 0.8659 -143.4903 207.8452)" width="15.992" height="15.992" />
      </g>
    </g>
    <g>
      <g>
        <rect x="100.362" y="156.004" transform="matrix(0.5 -0.866 0.866 0.5 -87.8516 175.8396)" width="16" height="16" />
      </g>
    </g>
    <g>
      <g>
        <rect x="363.615" y="308.032" transform="matrix(0.5 -0.866 0.866 0.5 -87.89 479.8291)" width="16" height="16" />
      </g>
    </g>
    <g>
      <g>
        <rect x="80" y="232" width="16" height="16" />
      </g>
    </g>
    <g>
      <g>
        <rect x="384" y="232" width="16" height="16" />
      </g>
    </g>
    <g>
      <g>
        <rect x="100.365" y="308.001" transform="matrix(0.8661 -0.4999 0.4999 0.8661 -143.4624 96.4955)" width="16" height="16" />
      </g>
    </g>
    <g>
      <g>
        <rect x="363.607" y="155.99" transform="matrix(0.866 -0.5 0.5 0.866 -32.2077 207.788)" width="16" height="16" />
      </g>
    </g>
    <g>
      <g>

        <rect x="155.97" y="363.629" transform="matrix(0.5001 -0.8659 0.8659 0.5001 -239.8465 327.747)" width="15.992" height="15.992" />
      </g>
    </g>
    <g>
      <g>

        <rect x="308.005" y="100.375" transform="matrix(0.5001 -0.8659 0.8659 0.5001 64.1135 327.8111)" width="15.992" height="15.992" />
      </g>
    </g>
    <g>
      <g>
        <path d="M232,112v123.472l-76.12,45.672l8.24,13.712l80-48c2.407-1.446,3.88-4.048,3.88-6.856V112H232z" />
      </g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
  </svg >

)

export const Locale = ()=>
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.66665 6.66658H18.3333M9.99998 19.1666C15.0625 19.1666 19.1666 15.0624 19.1666 9.99992C19.1666 4.93742 15.0625 0.833252 9.99998 0.833252C4.93748 0.833252 0.833313 4.93742 0.833313 9.99992C0.833313 15.0624 4.93748 19.1666 9.99998 19.1666ZM9.99998 19.1666C12.5 19.1666 13.3333 14.9999 13.3333 9.99992C13.3333 4.99992 12.5 0.833252 9.99998 0.833252C7.49998 0.833252 6.66665 4.99992 6.66665 9.99992C6.66665 14.9999 7.49998 19.1666 9.99998 19.1666ZM1.66665 13.3333H18.3333H1.66665Z" stroke="white" stroke-width="2"/>
</svg>
